import React, { useEffect } from "react";
import {AdminDataTable, AdminStatusBadge, AdminTableAction, AdminTableActions} from '../AdminDataTable/AdminDataTable';

export function TablaUsuarios({usuarios, mostrarUsuario }) {
  useEffect(() => {

  }, [usuarios]);

  const Vendedor = (vendedor) => {
    if (vendedor == null) {
      return "SIN ASIGNAR"
    } else {
      return vendedor
    }
  }

  const columns = [
    { name: 'Nombre comercial / Contacto', selector: row => `${row.nombre} / ${row.apellido}`, sortable: true, wrap: true, grow: 2 },
    { name: 'Vendedor', cell: row => Vendedor(row.vendedor), sortable: true, wrap: true },
    { name: 'Status', selector: row => row.estatus || '', cell: row => <AdminStatusBadge status={row.estatus} />, sortable: true, wrap: true },
    {
      name: 'Acciones',
      cell: row => (
        <AdminTableActions><AdminTableAction variant='edit' title='Editar' icon='fas fa-pen' onClick={() => mostrarUsuario(row.id)} /></AdminTableActions>
      )
    }
  ]

  return (
    <AdminDataTable
      columns={columns}
      data={usuarios}
      pagination
      paginationPerPage={100}
      paginationRowsPerPageOptions={[100, 200, 300, usuarios.length]}
      noDataComponent="No hay distribuidores registrados"
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
      }}
    />
  );
}
